export const getConfig = () => window.APP_CONFIG;
